import { render } from "./BigBagPage.vue?vue&type=template&id=c93a85fc&scoped=true"
import script from "./BigBagPage.vue?vue&type=script&lang=js"
export * from "./BigBagPage.vue?vue&type=script&lang=js"

import "./BigBagPage.vue?vue&type=style&index=0&id=c93a85fc&scoped=true&lang=css"

import exportComponent from "/Users/alpha/Documents/IONS/project/pit-story/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c93a85fc"]])

export default __exports__